"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    operationDescriptions: function() {
        return operationDescriptions;
    },
    validatePivotRequest: function() {
        return validatePivotRequest;
    },
    validateAsPivotTable: function() {
        return validateAsPivotTable;
    }
});
const operationDescriptions = {
    sum: 'Sum',
    avg: 'Mean',
    geo: 'Geometric Mean',
    std: 'Standard Deviation',
    count: 'Count',
    min: 'Minimum',
    max: 'Maximum'
};
function validatePivotRequest(req) {
    if (!req) {
        return 'Pivot request is null.';
    }
    if (!req.group_by || req.group_by.length === 0) {
        return 'Pivot must have at least one GroupBy.';
    }
    return '';
}
function validateAsPivotTable(req) {
    const invalid = validatePivotRequest(req);
    if (invalid) {
        return invalid;
    }
    if (!req.summary || req.summary.length === 0) {
        return 'Must have at least one Summary operation.';
    }
    return '';
}
